<aura-dialog-layout [title]="data.title" [hideActions]="true">
  <div dialog-content class="flex flex-col">
    @if (currentStep(); as currentStep) {
      <div>
        <section class="flex">
          @if (canGoBack) {
            <button mat-button class="tertiary" (click)="onBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
          }
          <h2 class="mx-6 content-center text-center text-3xl font-semibold">
            {{ currentStep.title }}
          </h2>
        </section>
        @if (currentStep.description) {
          <div class="text mt-3 text-center">{{ currentStep.description }}</div>
        }
      </div>
      <div class="mt-4">
        @if (currentStep.type === 'stepper') {
          @for (tab of currentStep.tabs; track $index) {
            <button mat-button class="link flex w-full" (click)="onTabClick(tab)">
              <div class="flex w-full items-center gap-4 py-6">
                @if (tab.icon) {
                  <mat-icon>{{ tab.icon }}</mat-icon>
                }
                <div class="mx-2 flex w-full items-center justify-between">
                  <div class="text-xl font-semibold">{{ tab.label }}</div>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </button>
            @if ($index !== currentStep.tabs!.length - 1) {
              <mat-divider></mat-divider>
            }
          }
        } @else if (currentStep.type === 'email_code' || currentStep.type === 'sms_code') {
          <aura-input-code-verification
            [label]="'Code de vérification'"
            [length]="8"
            (complete)="verifyToken($event)"
            (resend)="resend()"
          />
          @if (resendCount() >= 1) {
            <button mat-button class="link" (click)="firstStep()">Essayer une autre option</button>
          }
        }
      </div>
    }
  </div>
</aura-dialog-layout>
